module.exports = __webpack_public_path__ + "static/media/iitr_logo.71f031ec.png";